import { useCallback, useContext } from 'react'
import { MAIN_PATHS } from 'src/routes/main'

import { MENU_PATHS } from 'src/routes/menu'
import styled, { keyframes } from 'styled-components'
import { HistoryRouteContext } from 'src/routes'

import { postStartOpeningStory, postPlayChatNow } from 'src/services/post/postSkipOpeningStory'

import TapToStart from 'src/assets/img/opening/start-btn.png'
import PlayChatBtn from 'src/assets/img/opening/play-chat-btn.svg'
import BgOpening from 'src/assets/img/opening/bg-opening.png'
import Phone from 'src/assets/img/opening/phone.png'

export const OpeningPage = () => {
  const { redirectTo } = useContext(HistoryRouteContext)

  const redirect = useCallback((path) => redirectTo(path), [])

  const handleStartOpeningStory = () => {
    postStartOpeningStory()
    redirect(MENU_PATHS.OpeningStoryDetail.replace(':id', 'first-story'))
  }

  const handlePlayChatNow = () => {
    postPlayChatNow()
    redirect(MAIN_PATHS.RealtimePage)
  }

  return (
    <Wrapper>
      <img src={Phone} className="absolute left-1/2 top-[14dvh]" />
      <div
        className="absolute cursor-pointer bottom-[10%] left-1/2 z-10 transform -translate-x-1/2 w-full"
        onClick={() => handlePlayChatNow()}
      >
        <PillButton className="w-1/2 mx-auto">
          <PillButtonText>今直ぐチャットをplay</PillButtonText>
        </PillButton>
      </div>
      <div />
      <AnimatedContainer backgroundImage={TapToStart} onClick={() => handleStartOpeningStory()}>
        <ButtonText>オープニングストーリーSTART</ButtonText>
      </AnimatedContainer>
    </Wrapper>
  )
}

const fadeInFromBottom = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const Wrapper = styled.div.attrs({
  className: 'sm:w-[400px] w-screen h-[100dvh] mx-auto relative bg-no-repeat bg-left bg-cover'
})`
  background-image: url(${BgOpening});
  animation: ${fadeInFromBottom} 1.5s ease-out;
  animation-fill-mode: forwards;
`

const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`

const AnimatedContainer = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  background-image: url(${(props) => props.backgroundImage});
  background-size: 120%;
  background-position: center;
  width: 100%;
  height: 80px;
  animation: ${fadeInOut} 3s infinite ease-in-out;
`

const PillButton = styled.div`
  position: relative;
  height: 56px;
  background-image: url(${PlayChatBtn});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
`

const ButtonText = styled.span`
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  line-height: normal;
  letter-spacing: 2.24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

  @media (max-width: 375px) {
    font-size: 16px;
  }
`

const PillButtonText = styled(ButtonText)`
  font-size: 13px;
  letter-spacing: 2.24px;
  line-height: inherit;
`
